/**
 * Route for `real-time-event-alerts-conversion-chargeback-fraud-cap-hit`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeEventAlertsConversionChargebackFraudCapHitPage } from "../features/real-time-event-alerts-conversion-chargeback-fraud-cap-hit/RealTimeEventAlertsConversionChargebackFraudCapHitPage";

export const realTimeEventAlertsConversionChargebackFraudCapHitRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-event-alerts-conversion-chargeback-fraud-cap-hit",
	component: RealTimeEventAlertsConversionChargebackFraudCapHitPage,
});

export default realTimeEventAlertsConversionChargebackFraudCapHitRoute;
